// @flow

import React, { type Node } from 'react';

type HeaderProps = {|
  children: Node,
  size: 2,
|};

export function Header({ children, size }: HeaderProps): Node {
  switch (size) {
    case 2: return <h2 className="heading-2">{children}</h2>;
    default: throw new Error(`Header - invalid size "${size}"`);
  }
}
